module.exports = __webpack_public_path__ + "img/12-1_07.39439d04.jpg";